import {Component, OnInit} from '@angular/core';
import {ConfigService} from './config/config.service';
import {AuthService} from './auth/services/auth-service';

@Component({
  selector: 'my-app',
  template: `
  <nav-bar></nav-bar>
  <div>
    <home-component></home-component>
    <footer-component></footer-component>
  </div>
  `,
  providers: [AuthService, ConfigService],
})
export class AppComponent implements OnInit {
  constructor(private readonly authService: AuthService) {}

  ngOnInit() {
    this.authService.checkAuth().subscribe((authResult) => {
      if (!authResult.response.isAuthenticated && authResult.callbackError != null && authResult.callbackError.error !== null) {
        if (authResult.callbackError.error === 'access_denied' && authResult.callbackError.errorDescription.indexOf("not assigned") > 0) {
          window.location.replace('/nmdp_401.html');
        } else {
          window.location.replace('/nmdp_auth_error.html');
        }
      } else {

      }
    });
  }
}
